import { OrgTemplate01 } from "../Template/OrgTemplate01/OrgTemplate01";
import {OrgData} from './data';

export default function ORG() {
  return <OrgTemplate01 data={OrgData}></OrgTemplate01>;
}